
import { mdiCashFast } from '@mdi/js'
export default {
  props: {
    small: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: true
    },
    textColor: {
      type: String,
      default: 'orange'
    }
  },
  data () {
    return {
      mdiCashFast
    }
  }
}
